import { gql } from '@apollo/client';

import { IsSkippingEnabledQueryFragment } from 'types/graphql';

gql`
  fragment IsSkippingEnabledQuery on Query {
    userInTeam(teamSlug: $teamSlug)
    userIsTrackDeveloper(trackSlug: $trackSlug, teamSlug: $teamSlug)

    team(teamSlug: $teamSlug) {
      features {
        members_skip_to_challenge
      }
    }

    skippingEnabledTrack: track(trackSlug: $trackSlug, teamSlug: $teamSlug) {
      skipping_enabled
      can_skip
    }
  }
`;

export function isSkippingEnabled(data?: IsSkippingEnabledQueryFragment) {
  const teamSkipEnabled = data?.userInTeam && data?.team?.features?.members_skip_to_challenge;
  const trackSkipEnabled = data?.skippingEnabledTrack?.skipping_enabled && data?.skippingEnabledTrack.can_skip;

  return Boolean(data?.userIsTrackDeveloper || teamSkipEnabled || trackSkipEnabled);
}
